import React from 'react';
import ReactDOM from 'react-dom';
import PosterFlow from './containers/PosterFlow/PosterFlow';
import Root from './Root';

const filmGridContainer = document.querySelector('#film-grid-container');
const isHome = !!filmGridContainer;

if (isHome) {
  ReactDOM.render(
    <Root initialState={{ city: window.city }}>
      <PosterFlow />
    </Root>,
    filmGridContainer
  );
}
